import { type ReactNode } from 'react';
import { ComponentPanel } from '../../ComponentInfoCard/components/ComponentPanel';
import { type RequestProps } from '../../models/RequestProps';
import { CommentsPanel } from './CommentsPanel';
import { RequestPanel } from './RequestPanel';

export function RequestDetailsContent({ request }: RequestProps): ReactNode {
    return (
        <>
            <RequestPanel request={request} />
            <ComponentPanel componentId={request.componentID ?? ''} />
            <CommentsPanel comments={request.comments} />
        </>
    );
}
